import { useEffect } from "react";
import { type DropdownItemProps } from "semantic-ui-react";
import { first } from "lodash";
import { ValidatedForm } from "../../../../../components/forms";
import { type TrialPeriodSettingsProps } from "../types";
import cn from "classnames";
import styles from "./trialPeriodSettings.module.scss";

function TrialPeriodSettings(props: TrialPeriodSettingsProps) {
  const { onBlur, onChanged, validatedFieldProps, disabled, trialOptions, propertyNamePrefix, verticalStack } = props;
  const { isTrialAllowed, trialPeriodId } = props.values;

  const dropdownOptions: DropdownItemProps[] = trialOptions.map((option) => {
    return {
      text: option.name,
      value: option.id,
    };
  });

  const prefixedName = (name: string) => {
    return propertyNamePrefix ? `${propertyNamePrefix}.${name}` : name;
  };

  useEffect(() => {
    const selectedTrialPeriod = isTrialAllowed ? trialPeriodId ?? first(dropdownOptions)?.value : null;
    validatedFieldProps.setFieldValue(prefixedName("trialPeriodId"), selectedTrialPeriod);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isTrialAllowed]);

  return (
    <div className={cn(styles.root, { [styles["vertical-stack"]]: verticalStack })}>
      <div className={styles["checkbox-field"]}>
        <ValidatedForm.CheckboxField
          {...validatedFieldProps}
          value={isTrialAllowed}
          propertyName={prefixedName("isTrialAllowed")}
          toggle
          label={props.overrideLabel ?? "Offer free trial period?"}
          disabled={disabled}
          handleChange={onChanged}
        />
      </div>
      {isTrialAllowed && (
        <ValidatedForm.DropdownField
          {...validatedFieldProps}
          value={trialPeriodId}
          propertyName={prefixedName("trialPeriodId")}
          options={dropdownOptions}
          disabled={disabled}
          onChangeCallback={onChanged}
          handleBlur={onBlur}
          testID={"trial-period-dropdown"}
        />
      )}
    </div>
  );
}

export default TrialPeriodSettings;
